interface DrillRecord {
  id: string;
  scenario: string;
  region: string;
  rtoMinutes: number;
  rpoMinutes: number;
  result: 'Pass' | 'Warning' | 'Fail';
  runAt: string;
}

const records: DrillRecord[] = [
  { id: 'dr-001', scenario: 'Primary region failover', region: 'East US -> West US', rtoMinutes: 24, rpoMinutes: 6, result: 'Pass', runAt: '2026-04-28' },
  { id: 'dr-002', scenario: 'SQL geo-replica switch', region: 'West Europe -> North Europe', rtoMinutes: 41, rpoMinutes: 11, result: 'Warning', runAt: '2026-05-06' },
  { id: 'dr-003', scenario: 'Service Bus outage simulation', region: 'Global', rtoMinutes: 17, rpoMinutes: 3, result: 'Pass', runAt: '2026-05-20' },
  { id: 'dr-004', scenario: 'Storage restore from backup', region: 'Japan East', rtoMinutes: 73, rpoMinutes: 32, result: 'Fail', runAt: '2026-06-01' },
];

export function DrStatusPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">DR Status</h1>
          <p className="text-sm text-ink-muted mt-1">Drill plans, historical records, and measured RTO/RPO performance.</p>
        </div>
        <button className="rounded-lg border border-accent/40 bg-accent/10 px-4 py-2 text-sm hover:bg-accent/20">Schedule Drill</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card"><div className="card-title">Latest RTO</div><div className="kpi-value">24m</div></div>
        <div className="card"><div className="card-title">Latest RPO</div><div className="kpi-value">6m</div></div>
        <div className="card"><div className="card-title">Quarter Pass Rate</div><div className="kpi-value text-good">75%</div></div>
      </div>

      <div className="card overflow-auto">
        <table className="w-full text-sm min-w-[860px]">
          <thead className="text-ink-muted border-b border-border">
            <tr>
              <th className="text-left py-2">Drill ID</th>
              <th className="text-left py-2">Scenario</th>
              <th className="text-left py-2">Region</th>
              <th className="text-left py-2">RTO</th>
              <th className="text-left py-2">RPO</th>
              <th className="text-left py-2">Result</th>
              <th className="text-left py-2">Run At</th>
            </tr>
          </thead>
          <tbody>
            {records.map((r) => (
              <tr key={r.id} className="border-b border-border/50 last:border-0">
                <td className="py-2">{r.id}</td>
                <td className="py-2">{r.scenario}</td>
                <td className="py-2">{r.region}</td>
                <td className="py-2">{r.rtoMinutes}m</td>
                <td className="py-2">{r.rpoMinutes}m</td>
                <td className="py-2"><span className={r.result === 'Pass' ? 'badge-good' : r.result === 'Warning' ? 'badge-warn' : 'badge-bad'}>{r.result}</span></td>
                <td className="py-2">{new Date(r.runAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
